import { Button } from 'antd';
import styled from 'styled-components';

export const StyledSubmitButton = styled(Button)`
  width: 100%;
  margin-block: 16px;
`;
